import { z } from 'zod'

// Sign In Schema
export const signInSchema = z.object({
  email: z.string().email('Please enter a valid email'),
  password: z.string().min(1, 'Password is required'),
})

export type SignInForm = z.infer<typeof signInSchema>

// Sign Up Schema
export const signUpSchema = z.object({
  firstName: z.string().min(2, 'First name must be at least 2 characters'),
  lastName: z.string().min(2, 'Last name must be at least 2 characters'),
  email: z.string().email('Please enter a valid email'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
  confirmPassword: z.string().min(1, 'Please confirm your password'),
}).refine(
  (data) => data.password === data.confirmPassword,
  {
    message: "Passwords don't match",
    path: ["confirmPassword"]
  }
)

export type SignUpForm = z.infer<typeof signUpSchema>

// Helper function to extract field schema from form schema
export const getFieldSchema = <T extends z.ZodObject<z.ZodRawShape>>(
  schema: T,
  fieldName: keyof z.infer<T>
): z.ZodSchema<unknown> => {
  return schema.shape[fieldName as string] as z.ZodSchema<unknown>
}

// Special validation for confirm password that needs access to password field
export const getConfirmPasswordSchema = (passwordValue: string) => {
  return z.string()
    .min(1, 'Please confirm your password')
    .refine((value) => value === passwordValue, {
      message: "Passwords don't match"
    })
} 